import { Component, Input, OnInit, ViewEncapsulation,ViewChild } from '@angular/core';
import { AppCmsUrlsInitializationService } from 'src/app/services/app-cms-urls-initialization.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { CmsContentService } from 'src/app/services/cms-content.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { environment } from 'src/environments/environment';
import { SwiperComponent } from "swiper/angular";
import { ModalController } from '@ionic/angular';
import SwiperCore, {
  A11y,
  EffectFade,
  Keyboard,
  Navigation,
  Pagination,
  Scrollbar,
  SwiperOptions,
} from 'swiper'; 
SwiperCore.use([Navigation, A11y, EffectFade, Keyboard, Pagination, Scrollbar]);
@Component({
  selector: 'app-esim-activate-cms',
  templateUrl: './esim-activate-cms.component.html',
  styleUrls: ['./esim-activate-cms.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EsimActivateCmsComponent implements OnInit {
  @Input() devictypes: any;
  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  nodes:any[]=[];
  mainHeading;
  data: any;
  ENV: any
  currentLanguage: string;
  constructor(private modalController: ModalController,private APPCMSIS: AppCmsUrlsInitializationService,private APPIS: ApplicationInitializationService,private UTS: UtilitiesService,private CCS:CmsContentService) { 
    this.currentLanguage = this.UTS.getLocaleLanguage();
  }
  baseUrl; 
  ngOnInit(): void {
    this.ENV = localStorage.getItem('ENV');
    console.log(this.devictypes);
    setTimeout(() => {
      this.init();
    }, 1000);
  }
  
  init(){
    let CMS_URLS = this.APPCMSIS.appInitializer.CMS_URLS;
    this.baseUrl = environment.HOST;
 
    let CMS_URL = null;
    let url = null;
    if (CMS_URLS && CMS_URLS.length > 0){
      CMS_URL = CMS_URLS.find((c) => c.cmsUrlCode == this.devictypes);
      url = this.APPIS.environmentConfig.CMS_URL_NEW_FRAGMENTPATH + CMS_URL.cmsUrlEn;
    }
    if (this.UTS.getLocaleLanguage() == 'ar'){
      url = this.APPIS.environmentConfig.CMS_URL_NEW_FRAGMENTPATH + CMS_URL.cmsUrlAr;
    }
    this.CCS.newFragemnetContentService(url).subscribe(
      (result: any) => {
        this.data = result?.data?.bauMainSectionByPath?.item;
        this.mainHeading = this.data?.mainHeading;
        this.nodes = this.data?.subSection[0]?.description?.json;
      },
      (error) => {
      }
    );
  }
  CLose(){
    this.modalController.dismiss()
  }
slideNext(){
  this.swiper.swiperRef.slideNext(100);
}
slidePrev(){
  this.swiper.swiperRef.slidePrev(100);
}
}